import {useState, useEffect} from "@wordpress/element"

export const useFetch = (url, update) => {

    const[data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    
    let options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token')
        }
    };
        
    useEffect(()=>{
        setLoading(true);
        fetch(url, options)
        .then((res)=>res.json())
        .then((data)=>{
            setData(data)
            setLoading(false)
        })
        .catch((error) => {
            setLoading(true);
        });
    }, [url, update])

    return {data, loading}
}